import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "h3"
}
const _hoisted_3 = {
  key: 1,
  class: "h3"
}
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass({ additional: true })
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "body" }, "Not understand ?", -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass({ controls: true })
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Loading ..."))
        : (_openBlock(), _createElementBlock("h3", _hoisted_3, _toDisplayString(_ctx.jokeText), 1)),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("button", {
          class: _normalizeClass(["btn warning animated", { button: true }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleShowClue(true)))
        }, [
          _createElementVNode("img", {
            src: _ctx.puzzleSrc,
            alt: "puzzle"
          }, null, 8, _hoisted_6)
        ]),
        _withDirectives(_createElementVNode("p", {
          class: _normalizeClass(["title", { jokeClueText: true }])
        }, _toDisplayString(_ctx.jokeClue), 513), [
          [_vShow, _ctx.isShowClue]
        ])
      ], 512), [
        [_vShow, _ctx.isJokeHasClue]
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "btn primary borderLess body-sm",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getNewJoke && _ctx.getNewJoke(...args)))
        }, " Generate new ")
      ])
    ])
  ]))
}